export default __webpack_public_path__ + "static/media/vg-logo-text.3aca96c7.png";